import { gql } from '@apollo/client';
import {
  addNewCalculationToOrderMutation,
  cancelOrderMutation,
  createCustomerMutation,
  getNBFContractMutation,
  removeCalculationFromOrderMutation,
  removeTradeInMutation,
  removeVehiclesFromOrderMutation,
  resumeOrderMutation,
  saveInsuranceMutation,
  saveTradeInMutation,
  sendReserveVehicleOrderMutation,
  signOrderMutation,
  updateCalculationFinancingMutation,
  updateCalculationMutation,
  updateCustomerInfoMutation,
  saveCustomerMutation,
  updateOrderMutation,
  updateReservedVehicleStockStatusBySerialNumberMutation,
  updateVehicleMutation,
  vehicleOrderDraftMutation,
  sendSigningJobMutation,
  updatePrerequisiteToOrderMutation,
  saveServiceContractFlagToOrderMutation,
  updateModelMutation,
  updateOrderForEcomMutation,
  createMinimalOrderMutation,
  saveOfferExpiryDateToOrderMutation,
  sendCancelConfirmOrderMutation,
  sendOrderMutation,
  createAndAddMarginToOrderMutation,
  updateOrderAndCalculationsWithChargesMutation,
  removeAlternateLeasingFromOrderMutation,
  addAlternateLeasingToOrderMutation,
  addAppointmentToDarsMutation,
  updateOrderAndCalculationsforUsedCarMutation,
  reProcessVehicleOrderMutation,
  updateDealerPriceExclVatByOrderIdMutation,
  nextErrorFragmentWithErrorMessage,
  orderFragments,
  sendVehicleMarginCalculationSalesMutation,
} from 'next-common';
import {
  createExistingOrderMutation,
  createExistingOrderWithVehicleAndVehicleEquipmentMutation,
  createExistingOrderWithVehicleMutation,
  updateVehicleOptionsOnOrderMutation,
} from 'common-graphql/mutations';

export const createExistingOrderMutationParsed = gql`
  ${createExistingOrderMutation}
`;

export const createExistingOrderWithVehicleMutationParsed = gql`
  ${createExistingOrderWithVehicleMutation}
`;

export const createExistingOrderWithVehicleAndVehicleEquipmentMutationParsed = gql`
  ${createExistingOrderWithVehicleAndVehicleEquipmentMutation}
`;

export const updateOrderMutationParsed = gql`
  ${updateOrderMutation}
`;

export const updateCalculationMutationParsed = gql`
  ${updateCalculationMutation}
`;

export const updateCalculationFinancingMutationParsed = gql`
  ${updateCalculationFinancingMutation}
`;

export const addNewCalculationToOrderParsed = gql`
  ${addNewCalculationToOrderMutation}
`;

export const removeCalculationFromOrderMutationParsed = gql`
  ${removeCalculationFromOrderMutation}
`;

export const addVehiclesToOrderMutationParsed = gql`
  mutation addVehiclesToOrder(
    $orderId: ID!
    $vehicles: [VehicleInput!]
    $options: [VehicleOptionInput!]
    $priceConjunctionList: [PriceConjunctionInput!]
    $input: OrderInput
  ) {
    addVehiclesToOrder(
      orderId: $orderId
      vehicles: $vehicles
      options: $options
      priceConjunctionList: $priceConjunctionList
      OrderInput: $input
    ) {
      ...order
      ...nextError
    }
  }
  ${orderFragments}
  ${nextErrorFragmentWithErrorMessage}
`;

export const addVehiclesToOrderAndVehicleEquipmentMutationParsed = gql`
  mutation addVehiclesAndVehicleEquipmentToOrder(
    $orderId: ID!
    $vehicles: [VehicleInput!]
    $options: [VehicleOptionInput!]
    $equipments: [VehicleEquipmentInput!]
    $priceConjunctionList: [PriceConjunctionInput!]
    $input: OrderInput
  ) {
    addVehiclesAndVehicleEquipmentToOrder(
      orderId: $orderId
      vehicles: $vehicles
      options: $options
      equipments: $equipments
      priceConjunctionList: $priceConjunctionList
      OrderInput: $input
    ) {
      ...order
      ...nextError
    }
  }
  ${orderFragments}
  ${nextErrorFragmentWithErrorMessage}
`;

export const removeVehiclesFromOrderMutationParsed = gql`
  ${removeVehiclesFromOrderMutation}
`;

export const updateVehicleMutationParsed = gql`
  ${updateVehicleMutation}
`;

export const cancelOrderMutationParsed = gql`
  ${cancelOrderMutation}
`;

export const resumeOrderMutationParsed = gql`
  ${resumeOrderMutation}
`;

export const addChosenOfferMutationParsed = gql`
  mutation addChosenOffer($orderId: ID!, $calculationId: ID!) {
    addChosenOffer(orderId: $orderId, calculationId: $calculationId) {
      ...order
      ...nextError
    }
  }
  ${orderFragments}
  ${nextErrorFragmentWithErrorMessage}
`;

export const createVehicleOrderDraftMutationParsed = gql`
  ${vehicleOrderDraftMutation}
`;

export const signOrderParsed = gql`
  ${signOrderMutation}
`;

export const sendSigningJobMutationParsed = gql`
  ${sendSigningJobMutation}
`;

export const saveInsuranceParsed = gql`
  ${saveInsuranceMutation}
`;

export const sendOrderMutationParsed = gql`
  ${sendOrderMutation}
`;

export const createAndAddMarginToOrderMutationParsed = gql`
  ${createAndAddMarginToOrderMutation}
`;

export const saveTradeInMutationParsed = gql`
  ${saveTradeInMutation}
`;

export const removeTradeInMutationParsed = gql`
  ${removeTradeInMutation}
`;

export const createCustomerMutationParsed = gql`
  ${createCustomerMutation}
`;

export const saveCustomerMutationParsed = gql`
  ${saveCustomerMutation}
`;

export const updateCustomerInfoParsed = gql`
  ${updateCustomerInfoMutation}
`;

export const getNBFContractMutationParsed = gql`
  ${getNBFContractMutation}
`;

export const saveOfferExpiryDateToOrderMutationParsed = gql`
  ${saveOfferExpiryDateToOrderMutation}
`;

export const sendReserveVehicleOrderMutationParsed = gql`
  ${sendReserveVehicleOrderMutation}
`;

export const sendCancelConfirmOrderMutationParsed = gql`
  ${sendCancelConfirmOrderMutation}
`;

export const updateReservedVehicleStockStatusBySerialNumberMutationParsed = gql`
  ${updateReservedVehicleStockStatusBySerialNumberMutation}
`;

export const updateOrderPrerequisiteParsed = gql`
  ${updatePrerequisiteToOrderMutation}
`;

export const saveServiceContractFlagToOrderMutationParsed = gql`
  ${saveServiceContractFlagToOrderMutation}
`;

export const updateModelMutationParsed = gql`
  ${updateModelMutation}
`;

export const updateOrderForEcomMutationParsed = gql`
  ${updateOrderForEcomMutation}
`;

export const createMinimalOrderMutationParsed = gql`
  ${createMinimalOrderMutation}
`;

export const addAlternateLeasingToOrderMutationParsed = gql`
  ${addAlternateLeasingToOrderMutation}
`;

export const removeAlternateLeasingFromOrderMutationParsed = gql`
  ${removeAlternateLeasingFromOrderMutation}
`;

export const updateOrderAndCalculationsWithChargesMutationParsed = gql`
  ${updateOrderAndCalculationsWithChargesMutation}
`;

export const addAppointmentToDarsMutationParsed = gql`
  ${addAppointmentToDarsMutation}
`;

export const updateOrderAndCalculationsforUsedCarMutationParsed = gql`
  ${updateOrderAndCalculationsforUsedCarMutation}
`;

export const updateDealerPriceForArticles = gql`
  ${updateDealerPriceExclVatByOrderIdMutation}
`;

export const reProcessVehicleOrderMutationParsed = gql`
  ${reProcessVehicleOrderMutation}
`;

export const sendVehicleMarginCalculationSalesMutationParsed = gql`
  ${sendVehicleMarginCalculationSalesMutation}
`;

export const updateVehicleOptionsOnOrderMutationParsed = gql`
  ${updateVehicleOptionsOnOrderMutation}
`;
